module.exports = __webpack_public_path__ + "static/media/RA3WIFI.ff2cc54d.gif";